/* eslint-disable */
export default {
  mute: 'Désactiver le micro',
  unmute: 'Réactiver le micro',
  hangup: 'Raccrocher',
  reject: 'Rejeter',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
